module.exports = __webpack_public_path__ + "static/media/016ty@2x.8fd090e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/016ty@2x.png
// module id = 1665
// module chunks = 0 1